import SectionAlarmsProvider from '@/providers/SectionAlarmsProvider'

class SectionAlarmsService {
  async getShuntStates (token, objectId, dtFrom, dtTo) {
    return SectionAlarmsProvider.getShuntStates(token, objectId, dtFrom, dtTo)
  }
}

export default new SectionAlarmsService()



// WEBPACK FOOTER //
// ./src/services/api/axleshunt/SectionAlarmService.js